<template>
  <el-drawer custom-class="user_info_modal" v-model="modelMainVisible" @open="openModal" @close="closeModal"
    :destroy-on-close="true" :append-to-body="true" :direction="'btt'">
    <el-button class="button_more" type="transparent" icon="el-icon-more" @click="bottomDropUp = true"></el-button>

    <el-carousel :class="user.files && user.files.length ? 'with_arrow' : ''" trigger="click" :autoplay="false">
      <el-carousel-item v-if="user.image || user.files.length">
        <img class="user_image" :src="user.image" v-if="user.image" />
        <el-empty class="user_image" v-else></el-empty>
      </el-carousel-item>
      <el-carousel-item :class="$filters.getFileType(file)" v-for="(file, i) in user.files" :key="file.src">
        <img class="user_image" :src="file.url" alt="" v-if="$filters.getFileType(file) == 'image'" />
        <video-js :options="videoPlayerOptions" :sources="videosSrc[i]" v-if="$filters.getFileType(file) == 'video'" />
      </el-carousel-item>
    </el-carousel>


    <div class="user_image_gradient"></div>
    <div class="user_info_wrapper user_info_wrapper-padding">
      <div class="info_wrapper user_main_info">
        <div class="image_text_comp">
          <div class="text_wrapper">
            <div class="main_text">{{ user.name }}</div>
            <span class="value">{{ user.address.address }} </span>

          </div>
        </div>
      </div>

      <div>
        <div class="info_wrapper" v-if="user?.scripts?.weekdays">
          <span class="locumate_icons locumate_icon-notes"></span>
          <div class="info_value">
            <span>
              Average scripts per day (weekdays)
            </span>
            <span class="value">
              {{ user.scripts.weekdays }}
            </span>
          </div>
        </div>
        <div class="info_wrapper" v-if="user?.scripts?.saturday">
          <span class="locumate_icons locumate_icon-notes"></span>
          <div class="info_value">
            <span>
              Average scripts on Saturday
            </span>
            <span class="value">
              {{ user?.scripts?.saturday }}
            </span>
          </div>
        </div>
        <div class="info_wrapper" v-if="user?.scripts?.sunday">
          <span class="locumate_icons locumate_icon-notes"></span>
          <div class="info_value">
            <span>
              Average scripts on Sunday
            </span>
            <span class="value">
              {{ user?.scripts?.sunday }}
            </span>
          </div>
        </div>
        <div class="info_wrapper" v-if="user?.software">
          <span class="locumate_icons locumate_icon-settings"></span>
          <div class="info_value">
            <span>
              Dispensing software
            </span>
            <span class="value" v-if="user?.software === 'Other'">
              Other: {{ user.softwareOther }}
            </span>
            <span class="value" v-else>
              {{ user?.software }}
            </span>
          </div>
        </div>
        <div class="info_wrapper services" v-if="user?.services.length > 0">
          <span class="locumate_icons locumate_icon-settings"></span>
          <div class="info_value">
            <span>
              Services
            </span>
            <span class="value">
              <el-tag class="white" v-for="service in user.services" :key="service" size="small">{{
                service }}</el-tag>
            </span>
          </div>
        </div>
        <div class="info_wrapper services" v-if="user?.settings?.additionalEmail1">
          <!-- <span class="locumate_icons locumate_icon-settings"></span> -->
          <div class="info_value">
            <span class="section-title" v-if="$filters.employerType(user)"> Pharmacy Contacts </span>
            <span class="section-title" v-if="!$filters.employerType(user)"> Employer Contacts </span>
            <div class="pharmacy-contacts">
              <div v-if="user?.settings?.additionalName1" class="d-flex gap-3 align-items-center w-full">

                <el-avatar :size="60" shape="square" icon="el-icon-user-solid"></el-avatar>
                <div class="pharmacy-contact-details">
                  <span class="value pharmacy-contact-name">{{ user?.settings?.additionalName1 }}
                  </span>
                  <!-- <span class="value">{{ user?.settings?.additionalPhone1 }} </span> -->
                  <!-- <span class="value">{{ user?.settings?.additionalEmail1 }} </span> -->
                </div>
                <div class="ml-auto contact-options">
                  <div class="d-flex gap-1 align-items-center pl-2">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.2875 11.2125L6.9 12.6C6.6075 12.8925 6.1425 12.8925 5.8425 12.6075C5.76 12.525 5.6775 12.45 5.595 12.3675C4.8225 11.5875 4.125 10.77 3.5025 9.915C2.8875 9.06 2.3925 8.205 2.0325 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.1225 9.99 8.205 10.065 8.28 10.14C8.58 10.4325 8.5875 10.9125 8.2875 11.2125Z"
                        fill="#00B7AF" />
                      <path
                        d="M16.4776 13.7468C16.4776 13.9568 16.4401 14.1743 16.3651 14.3843C16.3426 14.4443 16.3201 14.5043 16.2901 14.5643C16.1626 14.8343 15.9976 15.0893 15.7801 15.3293C15.4126 15.7343 15.0076 16.0268 14.5501 16.2143C14.5426 16.2143 14.5351 16.2218 14.5276 16.2218C14.0851 16.4018 13.6051 16.4993 13.0876 16.4993C12.3226 16.4993 11.5051 16.3193 10.6426 15.9518C9.78007 15.5843 8.91757 15.0893 8.06257 14.4668C7.77007 14.2493 7.47757 14.0318 7.20007 13.7993L9.65257 11.3468C9.86257 11.5043 10.0501 11.6243 10.2076 11.7068C10.2451 11.7218 10.2901 11.7443 10.3426 11.7668C10.4026 11.7893 10.4626 11.7968 10.5301 11.7968C10.6576 11.7968 10.7551 11.7518 10.8376 11.6693L11.4076 11.1068C11.5951 10.9193 11.7751 10.7768 11.9476 10.6868C12.1201 10.5818 12.2926 10.5293 12.4801 10.5293C12.6226 10.5293 12.7726 10.5593 12.9376 10.6268C13.1026 10.6943 13.2751 10.7918 13.4626 10.9193L15.9451 12.6818C16.1401 12.8168 16.2751 12.9743 16.3576 13.1618C16.4326 13.3493 16.4776 13.5368 16.4776 13.7468Z"
                        fill="#00B7AF" />
                    </svg>

                    <span class="value">{{ user?.settings?.additionalPhone1 }} </span>
                  </div>
                  <div class="d-flex gap-1 align-items-center pl-2">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.5 6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375H5.25"
                        stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="#00B7AF"
                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M1.5 12.375H6" stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M1.5 9.375H3.75" stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <span class="value">{{ user?.settings?.additionalEmail1 }} </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="el-dialog__footer">

      <div class="el-dialog__footer">
        <el-button class="submit_page" type="black" @click="goToMap()">
          <span class="locumate_icons locumate_icon-map"></span><span>Map</span>
        </el-button>
        <!-- <el-button class="submit_page" type="blue" @click="goToChat()">
                <span class="locumate_icons locumate_icon-message"></span><span>Chat</span>
            </el-button> -->
      </div>

    </div>
  </el-drawer>
  <el-drawer custom-class="bottom_drop_up" v-model="bottomDropUp" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true">
    <el-button type="transparent" class="menu_item" @click="sendReport(user)">
      <span class="locumate_icons locumate_icon-flag"></span>
      <span v-if="$filters.employerType(user)">Report this pharmacy</span>
      <span v-if="!$filters.employerType(user)">Report this employer</span>

    </el-button>
  </el-drawer>
</template>
  
  <script>
  
  import {
    ref,
    // reactive,
    onMounted,
    inject,
    computed,
    nextTick,
  
    // nextTick
  } from "vue";
  import { useStore } from "vuex";
  
//   import store from "@/store/store";
import {
    useRouter
} from "vue-router";
// import { directions } from "@googlemaps/google-maps-services-js/dist/directions";

  export default {
    components: {
     
    },
    props: {
      modalName: {
        type: String,
      },
      options: {
        type: Object,
      },
    },
    setup(props) {
      console.log("🚀 ~ file: Agency.vue:127 ~ setup ~ props:", props)
      const $store = useStore();
      const $mitt = inject("$mitt");
      const $router = useRouter();
      // const pusher = inject(['pusher']);
    //   const $modals = inject("$modals");
      // const loading = ref(true);
      const modelMainVisible = ref(false);
  
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
      const user = computed(() => {
        return props.options.user;
      });
   
  
      const bottomDropUp = ref(false);
      $mitt.on(props.modalName, (options) => {
        modelMainVisible.value = options.show;
      });
  
  
      const sendReport = (user) => {
            bottomDropUp.value = false;
            $store.dispatch("setReportData", {
                userData: user,
            });
            $router.push({
                name: "report",
                params: {
                    userId: user.id,
                },
            });
        };
  
        const goToChat = () => {
            closeModal();
            const chatId =
                userRole == "pharmacy" ?
                    userData.id + "." + user.value.id :
                    user.value.id + "." + userData.id;
            // pusher.pusherChatSubscribe(chatId)
            $router.push({
                name: "chat_message",
                params: {
                    chatId: chatId,
                    // opponentId: user.value.id
                },
            });
        };

        const goToMap = () => {
            closeModal();

            // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
            // https://www.google.com/maps/search/?api=1&query=
            // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)

            if (
                navigator.platform.indexOf("iPhone") != -1 ||
                navigator.platform.indexOf("iPod") != -1 ||
                navigator.platform.indexOf("MacIntel") != -1 ||
                navigator.platform.indexOf("iPad") != -1
            ) {
                const originCord = userData.address.lat + "," + userData.address.lng;

                const destinationCord =
                    user.value.address.lat + "," + user.value.address.lng;

                const origin = userData.address ? `saddr=${originCord}&` : "";

                const destination = user.value.address ?
                    `daddr=${destinationCord}&` :
                    "";

                window.open(
                    `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
                );
            }

            // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
            // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
            else {
                const zoom = `&zoom=16`;
                const origin = userData.address.lat ?
                    `&origin=${userData.address.lat},${userData.address.lng}` :
                    "";
                const destination = user.value.address.lat ?
                    `&destination=${user.value.address.lat},${user.value.address.lng}` :
                    "";
                window.open(
                    `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
                );
            }
        };
      onMounted(() => {
        console.log("hhhhh");
      });
  
      const carouselHeight = ref(null);
  
      const setCarouselHeight = () => {
        setTimeout(() => {
          nextTick(console.log($(".el-carousel").width()));
          $(".el-carousel").css(
            "--carousel-height",
            `${$(".el-dialog__body").width()}px`
          );
        }, 500);
  
        // $('.el-carousel').css('--carousel-height', `${$('.el-carousel')[0].innerWidth}px`);
      };
  
      const videoPlayer = ref([]);
    
  
      let videosSrc = [];
  
      const openModal = () => {
        window.addEventListener("resize", setCarouselHeight);
        setCarouselHeight();
  
      
  
      };
      const closeModal = () => {
        modelMainVisible.value = false;
      };
     
  
      return {
        openModal,
        closeModal,
        // loading,
        modelMainVisible,
        user,
        userRole,
        carouselHeight,
        videoPlayer,
        videosSrc,
        sendReport,
        bottomDropUp,
        goToChat,
        goToMap
      };
    },
  };
  </script>
  